import { useTranslation } from "react-i18next";
import { Layers, ShieldCheck, Fingerprint, Quote } from "lucide-react";

export function BrandPanel(): React.ReactElement {
  const { t } = useTranslation();

  return (
    <div
      className="hidden lg:flex lg:w-1/2 relative flex-col justify-between p-16 bg-surface border-r border-border overflow-hidden"
      aria-hidden="true"
    >
      {/* Background blur decorations */}
      <div className="absolute -top-24 -left-24 w-96 h-96 bg-success/5 blur-[100px] rounded-full" />
      <div className="absolute bottom-48 right-0 w-64 h-64 bg-rose/5 blur-[80px] rounded-full" />

      {/* Top: Logo + Headlines */}
      <div className="relative z-10">
        <div className="flex items-center gap-3 group cursor-pointer mb-12">
          <div className="w-10 h-10 bg-gradient-to-br from-accent to-success rounded-xl flex items-center justify-center shadow-lg group-hover:rotate-6 transition-transform">
            <Layers className="w-6 h-6 text-background" />
          </div>
          <span className="text-xl font-bold tracking-tight text-foreground">
            Neural <span className="text-success">AI</span>
          </span>
        </div>

        <div className="space-y-6 max-w-md">
          <h1 className="text-4xl font-bold tracking-tight leading-tight text-foreground">
            {t("auth.brand.headline")}
          </h1>
          <p className="text-lg font-light text-foreground-secondary leading-relaxed">
            {t("auth.brand.subheadline")}
          </p>
        </div>
      </div>

      {/* Bottom: Testimonial + Badges */}
      <div className="relative z-10">
        <div className="bg-background p-8 rounded-[2.5rem] border border-border shadow-sm mb-8">
          <Quote className="w-8 h-8 text-success/20 mb-4" />
          <p className="text-foreground italic mb-6 leading-relaxed">
            &ldquo;{t("auth.brand.testimonial.quote")}&rdquo;
          </p>
          <div className="flex items-center gap-4">
            <div className="w-10 h-10 rounded-full bg-surface-secondary" />
            <div>
              <p className="text-sm font-bold text-foreground">
                {t("auth.brand.testimonial.name")}
              </p>
              <p className="text-[10px] uppercase tracking-widest font-mono text-foreground-muted">
                {t("auth.brand.testimonial.title")}, {t("auth.brand.testimonial.company")}
              </p>
            </div>
          </div>
        </div>

        <div className="flex gap-8 opacity-40 text-[10px] font-bold uppercase tracking-widest">
          <div className="flex items-center gap-2">
            <ShieldCheck className="w-4 h-4" />
            <span>{t("auth.brand.soc2")}</span>
          </div>
          <div className="flex items-center gap-2">
            <Fingerprint className="w-4 h-4" />
            <span>{t("auth.brand.gdpr")}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
